/*
 * Copyright (C) 2024 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and
 * should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly
 * prohibited.
 */

import {Stack, Typography} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import React from 'react';

interface BeamHelpTextProps {
  helpText?: string;
}

export const BeamHelpText = ({ helpText }: BeamHelpTextProps) => {
  return helpText ? (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <InfoIcon style={{ color: '#9fafbc' }} fontSize="small" />
      <Typography variant="subtitle2" style={{ color: '#9fafbc' }}>
        {helpText}
      </Typography>
    </Stack>
  ) : (
    <></>
  );
};
